export const locations = [
    "krishnagiri","Bangalore", "Chennai", "Hyderabad", "Pune", "Mumbai", "Delhi", "Remote"
];

export const courses = [
    "B.Tech", "B.E", "M.Tech", "MBA", "B.Sc", "M.Sc", "BCA", "MCA"
];

export const specializations = [
    "Computer Science", "Information Technology", "Mechanical", "Civil", "Electronics", "Electrical", "AI & ML"
];
  
export const institutes = [
    "IIT Bombay", "IIT Madras", "Anna University", "NIT Trichy", "VIT Vellore", "SRM University", "Manipal University"
];

export const startYears =Array.from ({length: 50},(_,i) =>(2025 - i)) ;
export const endYears =Array.from ({length: 50},(_,i) =>(2026 - i)) ;

export const skills = [
    "JavaScript", "React", "Python", "Java", "SQL", "Node.js", "HTML", "CSS", "Django", "FastAPI"
];
  


